/**
 * First-run state for the org Templates library, on the shared
 * `DocumentListEmptyState` shell (single muted icon → headline → description →
 * bare-text CTA) so it reads consistently with the Documents and Knowledge Base
 * tabs. Keeps the templates-specific copy — only the shell is shared.
 */
import { LayoutTemplate } from "lucide-react";

import { Button } from "@/components/ui/button";

export function TemplatesEmptyState({ onUpload }: { onUpload?: () => void }) {
    return (
        <div
            data-testid="templates-empty"
            className="flex min-h-64 items-center justify-center px-4 py-12"
        >
            <div className="flex flex-col items-center justify-center gap-3 text-center">
                <LayoutTemplate
                    className="text-muted-foreground/40 size-12"
                    aria-hidden
                />
                <div className="max-w-md">
                    <p className="text-sm font-medium">
                        Upload a template Polly can fill
                    </p>
                    <p className="text-muted-foreground mt-0.5 max-w-md text-xs">
                        Bring in a spreadsheet or PDF you fill out over and over
                        — a renewal summary, loss run, or ACORD form. Polly
                        fills a fresh copy from any conversation, no re-keying.
                    </p>
                </div>
                {onUpload && (
                    <Button size="sm" onClick={onUpload}>
                        Upload template
                    </Button>
                )}
            </div>
        </div>
    );
}
